<!-- Detalle de Centro — nuevo diseño (ui-redesign). Hero del prototipo + re-skin .ds. -->
<div class="ds detail-v2 centro-detail" [class.is-viewing]="!isEditing && !isCreating">
  <div class="wrap">
    <div class="cover" *ngIf="centro">
      <div class="ph" [class.has-img]="!!coverImageSrc">
        <img *ngIf="coverImageSrc" class="cover-img" [src]="coverImageSrc" alt="" />
      </div>
      <div class="cover-grad"></div>
    </div>
    <div class="detail-card centro-hero">
      <div class="dc-top">
        <!-- Mismo icono que identifica Centros en el header (menu.constants) -->
        <div class="dc-emblem"><mat-icon>apartment</mat-icon></div>
        <div class="dc-head" style="flex: 1">
          <app-contract-codes [contract]="{ codigo: centro?.codigo, codigoCorto: codigoCortoCentro }" titleKey="centro.codes.popTitle" mainLabelKey="centro.codes.codigo"><div class="dc-code">{{ centro?.codigo || "—" }}<button *ngIf="centro?.codigo" type="button" class="code-copy" (click)="copyCodigo(centro?.codigo)" [matTooltip]="'contracts.codes.copy' | translate"><mat-icon [inline]="true">content_copy</mat-icon></button></div></app-contract-codes>
          <h1>{{ heroDescripcion || centro?.codigo || ("centro.centroData.titleGeneral" | translate) }}</h1>
        </div>
        <div class="dc-actions">
          <button *ngIf="!isEditing && !isCreating" class="btn btn-ghost btn-sm" (click)="onBack()"><span class="ic"><mat-icon [inline]="true">arrow_back</mat-icon></span> {{ "common.back" | translate }}</button>

          <!-- Utilidades (dropdown propio .utils-menu del ds, según permisos; el
               trigger se ve si CUALQUIER item es visible: admin ∨ solicitar datos) -->
          <div class="utils-wrap" *ngIf="!isEditing && !isCreating && (centroDetailsComponent?.isAdmin || canSolicitarDatos)">
            <button type="button" class="btn btn-ghost btn-sm" [class.open]="utilsMenuOpen" (click)="toggleUtilsMenu()"><span class="ic"><mat-icon [inline]="true">build</mat-icon></span> {{ "common.utilities" | translate }} <mat-icon class="cv" [inline]="true">arrow_drop_down</mat-icon></button>
            <div class="utils-menu" [class.open]="utilsMenuOpen">
              <ng-container *ngIf="centroDetailsComponent?.isAdmin">
                <button type="button" class="utils-item" (click)="closeUtilsMenu(); centroDetailsComponent?.Validate()"><mat-icon class="ic">verified</mat-icon><span>{{ "centro.centroData.validate" | translate }}</span></button>
                <button type="button" class="utils-item" (click)="closeUtilsMenu(); centroDetailsComponent?.Migrar()"><mat-icon class="ic">cloud_sync</mat-icon><span>{{ "centro.utils.migrate" | translate }}</span></button>
              </ng-container>
              <button type="button" class="utils-item" *ngIf="canSolicitarDatos" (click)="closeUtilsMenu(); openSolicitudDatos()"><mat-icon class="ic">outgoing_mail</mat-icon><span>{{ "solicitudDatos.menu" | translate }}</span></button>
            </div>
          </div>

          <!-- Modo lectura -->
          <button class="btn btn-primary btn-sm" *ngIf="!isEditing && !isCreating && canEditCentro" (click)="enterEditMode()"><span class="ic"><mat-icon [inline]="true">edit</mat-icon></span> {{ "common.edit" | translate }}</button>
          <!-- Modo edición -->
          <button class="btn btn-ghost btn-sm" *ngIf="isEditing || isCreating" (click)="cancelEditMode()"><span class="ic"><mat-icon [inline]="true">close</mat-icon></span> {{ "common.cancel" | translate }}</button>
          <button class="btn btn-primary btn-sm" *ngIf="isEditing || isCreating" (click)="saveonly()"><span class="ic"><mat-icon [inline]="true">save</mat-icon></span> {{ "common.save" | translate }}</button>
        </div>
      </div>

      <!-- Meta-chips en fila propia A ANCHO COMPLETO de la card (fuera de dc-head para
           que no la acote la columna de acciones y no salten de línea con hueco libre) -->
      <div class="dc-meta dc-meta--hero" *ngIf="centro">
        <!-- Estado: mismo vocabulario que el formulario; en edición refleja el form en vivo -->
        <span class="pill" [ngClass]="heroActivo ? 'ok' : 'gray'">{{ (heroActivo ? "common.active" : "common.inactive") | translate }}</span>
        <!-- Código corto PERSISTIDO (ADR-0016): fijado en el alta, inmutable -->
        <span class="dc-chip" *ngIf="codigoCortoCentro" [matTooltip]="'centro.codes.cortoTip' | translate">
          <mat-icon>sell</mat-icon>
          <span class="dc-chip-tx">{{ "contracts.codes.corto" | translate }}: {{ codigoCortoCentro }}</span>
          <button type="button" class="code-copy" (click)="copyCodigo(codigoCortoCentro)" [matTooltip]="'contracts.codes.copy' | translate"><mat-icon [inline]="true">content_copy</mat-icon></button>
        </span>
        <!-- Contrato vinculado (cod + descripción), navegable -->
        <button
          type="button"
          class="dc-chip"
          *ngIf="contratoPadre"
          [matTooltip]="'lst.col.contract' | translate"
          (click)="goToContratoPadre()"
        >
          <mat-icon>description</mat-icon>
          <span class="dc-chip-code">{{ contratoPadre.codigo }}</span>
          <span class="dc-chip-tx">{{ contratoPadre.descripcion }}</span>
        </button>
        <!-- Tipo de instalación -->
        <span class="dc-chip" *ngIf="heroTipoInstalacion" [matTooltip]="'centro.centroData.installationType' | translate">
          <mat-icon>category</mat-icon>
          <span class="dc-chip-tx">{{ heroTipoInstalacion }}</span>
        </span>
        <!-- Centro de actividad -->
        <span class="dc-chip" *ngIf="heroCentroActividad" [matTooltip]="'centro.centroData.centerActivity' | translate">
          <mat-icon>workspaces</mat-icon>
          <span class="dc-chip-tx">{{ heroCentroActividad }}</span>
        </span>
      </div>
    </div>
    <mat-tab-group #tabGroup class="floating-tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="apartment"
            [label]="'centro.centroData.titleGeneral' | translate"
            [dirty]="isTabDirty(0)"
            [invalid]="isTabInvalid(0)"
            [dirtyTooltip]="'centro.edit.unsavedTab' | translate"
            [invalidTooltip]="'centro.edit.invalidTab' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-centro-details-card
            *ngIf="centro"
            [centro]="centro"
            [parent]="this"
            (detailFormComplete)="detailsFormStatus($event)"
            (centroDetailData)="detailsFormValue($event)"
            #CentroDetailsCardComponentRef
          >
          </app-centro-details-card>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="group"
            [label]="'centro.centroData.usersReportSostenibility' | translate"
            [dirty]="isTabDirty(1)"
            [invalid]="isTabInvalid(1)"
            [dirtyTooltip]="'centro.edit.unsavedTab' | translate"
            [invalidTooltip]="'centro.edit.invalidTab' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-centro-user-report-card
            *ngIf="centro && mainFormGroup"
            [centro]="centro"
            [parent]="this"
            [mainFormGroup]="mainFormGroup"
            #CentroUserReportCardComponentRef
          >
          </app-centro-user-report-card>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="layers"
            [label]="'centro.centroData.designData' | translate"
            [dirty]="isTabDirty(2)"
            [invalid]="isTabInvalid(2)"
            [dirtyTooltip]="'centro.edit.unsavedTab' | translate"
            [invalidTooltip]="'centro.edit.invalidTab' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-centro-design-data-card
            *ngIf="centro"
            [centro]="centro"
            [parent]="this"
            (designFormComplete)="designFormStatus($event)"
            (centroDesignData)="designFormValues($event)"
            #CentroDesignDataCardComponentRef
          >
          </app-centro-design-data-card>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="settings"
            [label]="'centro.centroData.operationData' | translate"
            [dirty]="isTabDirty(3)"
            [invalid]="isTabInvalid(3)"
            [dirtyTooltip]="'centro.edit.unsavedTab' | translate"
            [invalidTooltip]="'centro.edit.invalidTab' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-centro-operation-data-card
            *ngIf="centro"
            [centro]="centro"
            [parent]="this"
            (operationFormComplete)="operationFormStatus($event)"
            (centroOperationData)="operationFormValues($event)"
            #CentroOperationDataCardComponentRef
          >
          </app-centro-operation-data-card>
        </div>
      </mat-tab>

      <!-- ============ PERSONAS (contactos manuales + responsables fijos) ============ -->
      <mat-tab *ngIf="centro?.id && !isCreating">
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="people"
            [label]="'contacts.title' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-entity-contacts-tab
            [entityId]="centro.id"
            [entityType]="'Centro'"
            [entityName]="centro.descripcion || centro.codigo"
            [config]="{ allowCreate: canEditCentro, allowRemove: canEditCentro, readonly: !canEditCentro, showDetails: true }"
            (responsableNavigate)="goToResponsableTab($event)"
          >
          </app-entity-contacts-tab>
        </div>
      </mat-tab>

      <!-- ============ ENERGÍA (CUPS del centro) — oculta en edición/creación ============ -->
      <mat-tab *ngIf="centro?.id && !isEditing && !isCreating">
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="bolt"
            [label]="'energia.tab' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-energia-tab
            [centroId]="centro.id"
            [centroNombre]="centro.descripcion || centro.codigo"
            [canManage]="canManageEnergia"
            [centroActivo]="heroActivo"
          ></app-energia-tab>
        </div>
      </mat-tab>

      <!-- ============ PERSONALIZAR (pendiente de backend) ============ -->
      <mat-tab>
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="tune"
            [label]="'common.customize' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <div class="cards">
            <!-- Imagen de cabecera (movida desde Información general) -->
            <div class="card">
              <div class="sec-head">
                <span class="sec-tile purple"><mat-icon>image</mat-icon></span>
                <div>
                  <h3>{{ "customize.headerImage" | translate }}</h3>
                  <p>{{ "customize.headerImageSub" | translate }}</p>
                </div>
              </div>
              <!-- Edición: drop-area (arrastrar / clic) sobre el control imageDataB64 del centro -->
              <app-image-upload
                *ngIf="(isEditing || isCreating) && centroDetailsComponent?.myDetailForm"
                [formControl]="$any(centroDetailsComponent.myDetailForm.get('imageDataB64'))"
                [maxSizeMB]="1"
                [acceptedFormats]="['image/jpeg', 'image/png']"
                [hint]="'customize.headerImageSub' | translate"
              ></app-image-upload>
              <!-- Lectura: preview o vacío -->
              <div class="img-preview" *ngIf="!isEditing && !isCreating && coverImageSrc">
                <img [src]="coverImageSrc" alt="preview" />
              </div>
              <div class="det-empty" style="padding: 26px 16px" *ngIf="!isEditing && !isCreating && !coverImageSrc">
                <span class="ec-ic"><mat-icon>image</mat-icon></span>
                <p>{{ "contracts.noImageAvailable" | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- Historial (audit trail) — informativo, solo lectura; oculto en edición/creación -->
      <mat-tab *ngIf="centro?.id && canEditCentro && !isEditing && !isCreating">
        <ng-template mat-tab-label>
          <app-ds-tab-label
            icon="history"
            variant="info"
            [label]="'historial.tab' | translate"
          ></app-ds-tab-label>
        </ng-template>
        <div class="tab-content">
          <app-historial [entidadTipo]="'Centro'" [entidadId]="centro.id"></app-historial>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
